// @flow

import keyMirror from 'keymirror';

const ActionTypes = keyMirror({
  REDIRECT: null,

  ERROR_RESPONSE: null,

  LOGIN_RESPONSE_SUCCESS: null,
  LOGIN_RESPONSE_FAILURE: null,

  RESTAURANT_RESPONSE_SUCCESS: null,
  ME_RESPONSE_FAILURE: null,

  PUT_RESTAURANT_RESPONSE_SUCCESS: null,
  PUT_ME_RESPONSE_FAILURE: null,

  GET_RESTAURANT_SUCCESS: null,
  GET_RESTAURANT_FAILURE: null,

  POST_RESTAURANT_RESPONSE_SUCCESS: null,
  POST_RESTAURANT_RESPONSE_FAILURE: null,

  PUT_RESTAURANT_MULTIPART_RESPONSE_SUCCESS: null,
  PUT_RESTAURANT_MULTIPART_RESPONSE_FAILURE: null,

  PAYMENT_STATISTICS_RESPONSE_SUCCESS: null,
  PAYMENT_STATISTICS_RESPONSE_FAILURE: null,

  PAYMENT_PAYOUTS_RESPONSE_REQUEST: null,
  PAYMENT_PAYOUTS_RESPONSE_SUCCESS: null,
  PAYMENT_PAYOUTS_RESPONSE_FAILURE: null,

  PAYMENT_PAYINS_RESPONSE_REQUEST: null,
  PAYMENT_PAYINS_RESPONSE_SUCCESS: null,
  PAYMENT_PAYINS_RESPONSE_FAILURE: null,

  //
  // ORDER
  //

  ON_GOING_ORDERS_LISTRESPONSE_SUCCESS: null,
  ON_GOING_ORDERS_LISTRESPONSE_FAILURE: null,

  ORDERS_LIST_BY_MODIFICATION_DATE_RESPONSE_SUCCESS: null,
  ORDERS_LIST_BY_MODIFICATION_DATE_RESPONSE_FAILURE: null,

  GET_ORDERS_LIST_BY_DUE_DATE_RESPONSE_SUCCESS: null,
  GET_ORDERS_LIST_BY_DUE_DATE_RESPONSE_FAILURE: null,

  GET_ORDER_SETTINGS_SUCCESS: null,
  GET_ORDER_SETTINGS_FAILURE: null,

  PUT_ORDER_SETTINGS_SUCCESS: null,
  PUT_ORDER_SETTINGS_FAILURE: null,

  UPDATE_ORDER_RESPONSE_SUCCESS: null,
  UPDATE_ORDER_RESPONSE_FAILURE: null,

  GET_ORDER_STATISTICS_SUCCESS: null,
  GET_ORDER_STATISTICS_FAILURE: null,

  GET_CART_MODIFIERS: null,
  GET_CART_MODIFIERS_SUCCESS: null,
  GET_CART_MODIFIERS_FAILURE: null,

  GET_CART_MODIFIER: null,
  GET_CART_MODIFIER_SUCCESS: null,
  GET_CART_MODIFIER_FAILURE: null,

  PUT_CART_MODIFIER: null,
  PUT_CART_MODIFIER_SUCCESS: null,
  PUT_CART_MODIFIER_FAILURE: null,

  POST_CART_MODIFIER: null,
  POST_CART_MODIFIER_SUCCESS: null,
  POST_CART_MODIFIER_FAILURE: null,

  PUT_CART_MODIFIERS_PRIORITIES: null,
  PUT_CART_MODIFIERS_PRIORITIES_SUCCESS: null,
  PUT_CART_MODIFIERS_PRIORITIES_FAILURE: null,

  //
  // Reviewns
  //

  GET_REVIEWS_SUMMARY_RESPONSE_SUCCESS: null,
  GET_REVIEWS_SUMMARY_RESPONSE_FAILURE: null,

  GET_USER_REVIEWS_SUMMARY_RESPONSE_SUCCESS: null,
  GET_USER_REVIEWS_SUMMARY_RESPONSE_FAILURE: null,

  GET_CLAIMS_DISCUSSIONS_SETTINGS_RESPONSE_SUCCESS: null,
  GET_CLAIMS_DISCUSSIONS_SETTINGS_RESPONSE_FAILURE: null,

  PUT_CLAIMS_DISCUSSIONS_SETTINGS_RESPONSE_SUCCESS: null,
  PUT_CLAIMS_DISCUSSIONS_SETTINGS_RESPONSE_FAILURE: null,

  GET_USER_RESPONSE_SUCCESS: null,
  GET_USER_RESPONSE_FAILURE: null,

  GET_USER_PAYMENTS_RESPONSE_SUCCESS: null,
  GET_USER_PAYMENTS_RESPONSE_FAILURE: null,

  GET_BOOKINGS_RESPONSE_SUCCESS: null,
  GET_BOOKINGS_RESPONSE_FAILURE: null,

  GET_UPDATED_BOOKINGS_RESPONSE_SUCCESS: null,
  GET_UPDATED_BOOKINGS_RESPONSE_FAILURE: null,

  POST_BOOKING_RESPONSE_SUCCESS: null,
  POST_BOOKING_RESPONSE_FAILURE: null,

  PUT_SHOWN_BOOKING_REQUEST: null, //
  PUT_BOOKING_RESPONSE_SUCCESS: null,
  PUT_BOOKING_RESPONSE_FAILURE: null,

  GET_BOOKING_SETTINGS_RESPONSE_SUCCESS: null,
  GET_BOOKING_SETTINGS_RESPONSE_FAILURE: null,

  GET_CAPACITY_SPECIFICS_SUCCESS: null,
  GET_CAPACITY_SPECIFICS_FAILURE: null,

  PUT_CAPACITY_SPECIFIC_SUCCESS: null,
  PUT_CAPACITY_SPECIFIC_FAILURE: null,

  POST_CAPACITY_SPECIFIC_SUCCESS: null,
  POST_CAPACITY_SPECIFIC_FAILURE: null,

  DELETE_CAPACITY_SPECIFIC_SUCCESS: null,
  DELETE_CAPACITY_SPECIFIC_FAILURE: null,

  GET_UNSEEN_BOOKINGS_REQUEST: null, //
  GET_UNSEEN_BOOKINGS_RESPONSE_SUCCESS: null,
  GET_UNSEEN_BOOKINGS_RESPONSE_FAILURE: null,

  PUT_BOOKING_SETTINGS_RESPONSE_SUCCESS: null,
  PUT_BOOKING_SETTINGS_RESPONSE_FAILURE: null,

  GET_BOOKING_SPECIFICS_SETTINGS_SUCCESS: null,
  GET_BOOKING_SPECIFICS_SETTINGS_FAILURE: null,

  GET_WAITING_BOOKINGS_RESPONSE_SUCCESS: null,
  GET_WAITING_BOOKINGS_RESPONSE_FAILURE: null,

  GET_GUESTS_BOOKED_SUCCESS: null,
  GET_GUESTS_BOOKED_FAILURE: null,

  GET_BOOKING_SLOTS_RESPONSE_SUCCESS: null,
  GET_BOOKING_SLOTS_RESPONSE_FAILURE: null,

  PUT_BOOKING_SPECIFIC_SETTING_SUCCESS: null,
  PUT_BOOKING_SPECIFIC_SETTING_FAILURE: null,

  GET_PDF_BOOKINGS_LIST_LINK_SUCCESS: null,
  GET_PDF_BOOKINGS_LIST_LINK_FAILURE: null,

  //
  // News
  //

  GET_NEWS_LIST_RESPONSE_SUCCESS: null,
  GET_NEWS_LIST_RESPONSE_FAILURE: null,

  POST_NEWS_RESPONSE_SUCCESS: null,
  POST_NEWS_RESPONSE_FAILURE: null,

  PUT_NEWS_RESPONSE_SUCCESS: null,
  PUT_NEWS_RESPONSE_FAILURE: null,

  DELETE_NEWS_RESPONSE_SUCCESS: null,
  DELETE_NEWS_RESPONSE_FAILURE: null,

  //
  // MENU
  //
  GET_RESTAURANT_MENU: null,
  GET_RESTAURANT_MENU_RESPONSE_SUCCESS: null,
  GET_RESTAURANT_MENU_RESPONSE_FAILURE: null,

  GET_RESTAURANT_MENU_WITH_SYNCHRONIZATION_RESPONSE_SUCCESS: null,
  GET_RESTAURANT_MENU_WITH_SYNCHRONIZATION_RESPONSE_FAILURE: null,

  PUT_RESTAURANT_MENU_RESPONSE_SUCCESS: null,
  PUT_RESTAURANT_MENU_RESPONSE_FAILURE: null,

  //
  // Menu - Product
  //

  POST_RESTAURANT_MENU_PRODUCT_RESPONSE_SUCCESS: null,
  POST_RESTAURANT_MENU_PRODUCT_RESPONSE_FAILURE: null,

  PUT_RESTAURANT_MENU_PRODUCT_RESPONSE_SUCCESS: null,
  PUT_RESTAURANT_MENU_PRODUCT_RESPONSE_FAILURE: null,

  DELETE_RESTAURANT_MENU_PRODUCT_RESPONSE_SUCCESS: null,
  DELETE_RESTAURANT_MENU_PRODUCT_RESPONSE_FAILURE: null,

  DELETE_RESTAURANT_MENU_PRODUCT_IMAGE_RESPONSE_SUCCESS: null,
  DELETE_RESTAURANT_MENU_PRODUCT_IMAGE_RESPONSE_FAILURE: null,

  //
  // Menu - ProductOption
  //

  PUT_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS: null,
  PUT_RESTAURANT_MENU_PRODUCT_OPTION_FAILURE: null,

  DELETE_RESTAURANT_MENU_PRODUCT_OPTION_IMAGE_SUCCESS: null,
  DELETE_RESTAURANT_MENU_PRODUCT_OPTION_IMAGE_FAILURE: null,

  DELETE_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS: null,
  DELETE_RESTAURANT_MENU_PRODUCT_OPTION_FAILURE: null,

  POST_RESTAURANT_MENU_PRODUCT_OPTION_REQUEST: null,
  POST_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS: null,
  POST_RESTAURANT_MENU_PRODUCT_OPTION_FAILURE: null,

  //
  // Menu - Menu
  //

  PUT_RESTAURANT_MENU_MENU_RESPONSE_SUCCESS: null,
  PUT_RESTAURANT_MENU_MENU_RESPONSE_FAILURE: null,

  DELETE_RESTAURANT_MENU_MENU_IMAGE_RESPONSE_SUCCESS: null,
  DELETE_RESTAURANT_MENU_MENU_IMAGE_RESPONSE_FAILURE: null,

  DELETE_RESTAURANT_MENU_MENU_RESPONSE_SUCCESS: null,
  DELETE_RESTAURANT_MENU_MENU_RESPONSE_FAILURE: null,

  POST_RESTAURANT_MENU_MENU_RESPONSE_SUCCESS: null,
  POST_RESTAURANT_MENU_MENU_RESPONSE_FAILURE: null,

  //
  // Menu - MenuPart
  //
  PUT_RESTAURANT_MENU_MENU_PART_SUCCESS: null,
  PUT_RESTAURANT_MENU_MENU_PART_FAILURE: null,

  //
  // Menu - MenuPart - Category
  //
  PUT_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS: null,
  PUT_RESTAURANT_MENU_MENU_PART_CATEGORY_FAILURE: null,

  DELETE_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS: null,
  DELETE_RESTAURANT_MENU_MENU_PART_CATEGORY_FAILURE: null,

  //
  // Menu - category
  //

  PUT_RESTAURANT_MENU_CATEGORY_RESPONSE_SUCCESS: null,
  PUT_RESTAURANT_MENU_CATEGORY_RESPONSE_FAILURE: null,

  DELETE_RESTAURANT_MENU_CATEGORY_IMAGE_RESPONSE_SUCCESS: null,
  DELETE_RESTAURANT_MENU_CATEGORY_IMAGE_RESPONSE_FAILURE: null,

  DELETE_RESTAURANT_MENU_CATEGORY_RESPONSE_SUCCESS: null,
  DELETE_RESTAURANT_MENU_CATEGORY_RESPONSE_FAILURE: null,

  POST_RESTAURANT_MENU_CATEGORY_RESPONSE_SUCCESS: null,
  POST_RESTAURANT_MENU_CATEGORY_RESPONSE_FAILURE: null,

  //
  // Menu - upsellingCategory
  //

  PUT_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_SUCCESS: null,
  PUT_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_FAILURE: null,

  POST_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_SUCCESS: null,
  POST_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_FAILURE: null,

  DELETE_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_SUCCESS: null,
  DELETE_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_FAILURE: null,

  /**
   * Export
   */
  GET_EXPORT: null,
  GET_EXPORT_SUCCESS: null,
  GET_EXPORT_FAILURE: null,

  //
  // Dahboard
  //

  GET_RESTAURANT_DASHBOARD_RESPONSE_SUCCESS: null,
  GET_RESTAURANT_DASHBOARD_RESPONSE_FAILURE: null,

  //
  // Booking - Notifications
  //

  GET_BOOKING_NOTIFICATIONS_SETTINGS_RESPONSE_SUCCESS: null,
  GET_BOOKING_NOTIFICATIONS_SETTINGS_RESPONSE_FAILURE: null,

  //
  // Pro Accounts
  //
  PRO_FORGOT_PASSWORD_SUCCESS: null,
  PRO_FORGOT_PASSWORD_FAILURE: null,

  PRO_ACCOUNT_GET_ME_SUCCESS: null,
  PRO_ACCOUNT_GET_ME_FAILURE: null,

  PRO_ACCOUNT_CREATE_SUCCESS: null,
  PRO_ACCOUNT_CREATE_FAILURE: null,

  PRO_ACCOUNT_GET_SUCCESS: null,
  PRO_ACCOUNT_GET_FAILURE: null,

  PRO_ACCOUNT_UPDATE_SUCCESS: null,
  PRO_ACCOUNT_UPDATE_FAILURE: null,

  PRO_ACCOUNT_DELETE_SUCCESS: null,
  PRO_ACCOUNT_DELETE_FAILURE: null,

  PRO_ACCOUNT_GET_DOMAINS_SUCCESS: null,
  PRO_ACCOUNT_GET_DOMAINS_FAILURE: null,

  CHANGE_PRO_DOMAIN: null,

  //
  // RestaurantsGroup
  //

  GET_RESTAURANTS_GROUP_SUCCESS: null,
  GET_RESTAURANTS_GROUP_FAILURE: null,

  GET_RESTAURANT_FOR_GROUP_REQUEST: null, //
  GET_RESTAURANT_FOR_GROUP_SUCCESS: null,
  GET_RESTAURANT_FOR_GROUP_FAILURE: null,

  POST_RESTAURANTS_GROUP_SUCCESS: null,
  POST_RESTAURANTS_GROUP_FAILURE: null,

  PUT_RESTAURANTS_GROUP_SUCCESS: null,
  PUT_RESTAURANTS_GROUP_FAILURE: null,

  GET_RESTAURANT_ROLES_SUCCESS: null,
  GET_RESTAURANT_ROLES_FAILURE: null,

  GET_ORDER_STATISTICS: null,
  GET_ORDER_STATISTICS_SUCCESS: null,
  GET_ORDER_STATISTICS_FAILURE: null,

  GET_API_CONSUMERS: null,
  GET_API_CONSUMERS_SUCCESS: null,
  GET_API_CONSUMERS_FAILURE: null,

  //
  // Roles
  //

  PUT_ROLE_RESPONSE_SUCCESS: null,
  PUT_ROLE_RESPONSE_FAILURE: null,

  POST_ROLE_RESPONSE_SUCCESS: null,
  POST_ROLE_RESPONSE_FAILURE: null,

  DELETE_ROLE_RESPONSE_SUCCESS: null,
  DELETE_ROLE_RESPONSE_FAILURE: null,

  //
  // Security
  //

  PRO_ROLE_WITH_ELEVATION_CODE_SUCCESS: null,
  PRO_ROLE_WITH_ELEVATION_CODE_FAILURE: null,

  //
  // Kiosk settings
  //
  GET_KIOSK_SETTINGS_SUCCESS: null,
  GET_KIOSK_SETTINGS_FAILURE: null,

  PUT_KIOSK_SETTINGS_SUCCESS: null,
  PUT_KIOSK_SETTINGS_FAILURE: null,

  GET_CUSTOM_TEXTS_CONTAINER_SUCCESS: null,
  GET_CUSTOM_TEXTS_CONTAINER_FAILURE: null,
  POST_CUSTOM_TEXTS_CONTAINER_SUCCESS: null,
  POST_CUSTOM_TEXTS_CONTAINER_FAILURE: null,
  PUT_CUSTOM_TEXTS_CONTAINER_SUCCESS: null,
  PUT_CUSTOM_TEXTS_CONTAINER_FAILURE: null,

  //
  // Other
  //

  START_TIMER: null,
  STOP_TIMER: null,

  QUERY_UPDATE: null,

  LOGOUT: null,
});

export default ActionTypes;



// WEBPACK FOOTER //
// ./scripts/constants/ActionTypes.js